import NotistackProvider from "./components/NotistackProvider";
import ScrollToTop from "./components/ScrollToTop";
import MotionLazyContainer from "./components/animate/MotionLazyContainer";
import { ChartStyle } from "./components/chart";
import { ProgressBarStyle } from "./pages/ProgressBar";
import Router from "./routes";
import ThemeProvider from "./theme";
import ErrorBoundary from "./components/ErrorBoundary";
import { useEffect } from "react";
import { logError } from "~src/utils/logger";
function App() {
  useEffect(() => {
    try {
      if (window.top && window.top !== window.self) {
        window.top.location.href = window.self.location.href; // Redirect the top-level frame
      }
    } catch (error) {
      logError(`Error handling iframe prevention: ${error}`);
    }
  }, []);
  return (
    <ErrorBoundary>
      <MotionLazyContainer>
        <ThemeProvider>
          <NotistackProvider>
            <ProgressBarStyle />
            <ScrollToTop />
            <ChartStyle />
            <Router />
          </NotistackProvider>
        </ThemeProvider>
      </MotionLazyContainer>
    </ErrorBoundary>
  );
}

export default App;
